var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCustomers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 820.941,
    viewBox: "0 0 960 820.941",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-603.243 -269.319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1127.665,649.24a1.4,1.4,0,0,1-.759,1.15,3.525,3.525,0,0,1-1.84.474h-954.8c-1.435,0-2.6-.727-2.6-1.624s1.163-1.624,2.6-1.624h954.8a3.526,3.526,0,0,1,1.84.474,1.4,1.4,0,0,1,.759,1.15Z",
    transform: "translate(435.578 439.396)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1018.135 402.498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M829.416,262.475a20.424,20.424,0,0,1-3.152-.247l-117.17-18.383a20.412,20.412,0,0,1-16.913-23.839L716.624,86.513A20.346,20.346,0,0,1,739.676,70l115.261,16.99a20.411,20.411,0,0,1,17.153,23.553L849.555,245.428a20.489,20.489,0,0,1-20.141,17.047Z",
    transform: "translate(-691.847 -69.769)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.836,140.761a5.81,5.81,0,0,1-1.081-.1l-91.869-17.134A5.86,5.86,0,1,1,739.034,112l91.87,17.137a5.861,5.861,0,0,1-1.068,11.622Z",
    transform: "translate(-687.661 -86.729)",
    fill: "#002bfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.627,168.058a5.761,5.761,0,0,1-.8-.054l-88.08-12a5.86,5.86,0,1,1,1.583-11.612l88.079,12a5.86,5.86,0,0,1-.783,11.666Z",
    transform: "translate(-688.118 -83.357)",
    fill: "#002bfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.907,196.362a5.977,5.977,0,0,1-.943-.077l-59.53-9.634a5.86,5.86,0,1,1,1.874-11.57l59.53,9.634a5.861,5.861,0,0,1-.931,11.646Z",
    transform: "translate(-688.756 -80.178)",
    fill: "#002bfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.91,193.251a5.985,5.985,0,0,1-.943-.077l-39.534-6.523a5.86,5.86,0,1,1,1.874-11.57l39.534,6.523a5.861,5.861,0,0,1-.931,11.646Z",
    transform: "translate(-625.276 -23.318)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780.525 269.319)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.765,
    cy: 13.765,
    rx: 13.765,
    ry: 13.765,
    transform: "translate(27.288 129.871)",
    fill: "#002bfe"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.182,
    cy: 7.182,
    rx: 7.182,
    ry: 7.182,
    transform: "translate(60.804 10.174)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.182,
    cy: 7.182,
    rx: 7.182,
    ry: 7.182,
    transform: "translate(27.887 89.174)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.774,220.37a39.834,39.834,0,0,0-39.433,39.146c0,.2,0,1.6,0,3.423a10.1,10.1,0,0,0,10.1,10.1h0a10.1,10.1,0,0,0,10.1-10.109c0-1.246,0-2.106,0-2.159a19.152,19.152,0,1,1,29.482,16.123l0,0s-14.372,9.251-18.753,21.943h0a28.131,28.131,0,0,0-1.159,8.01c0,1.115.066,10.869.192,18.786a10.41,10.41,0,0,0,10.411,10.241h0A10.412,10.412,0,0,0,523.127,325.4c-.044-7.25-.068-15.692-.068-16.306,0-7.794,7.519-15.559,13.694-20.623a41.535,41.535,0,0,0,14.285-22.742,25.97,25.97,0,0,0,.748-5.634,39.724,39.724,0,0,0-40.012-39.724Z",
    transform: "translate(-472.195 -220.369)",
    fill: "#002bfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.954,306.766h0a10.1,10.1,0,0,1-10.1-10.1c0-1.829,0-3.225,0-3.424a39.351,39.351,0,0,1,4.6-17.927,39.442,39.442,0,0,0-7.588,22.715c0,.2,0,1.6,0,3.423a10.1,10.1,0,0,0,10.1,10.1h0a10.107,10.107,0,0,0,9.722-7.359A10.061,10.061,0,0,1,484.954,306.766Z",
    transform: "translate(-471.864 -258.876)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.139,280.215a19.152,19.152,0,0,1,16.656,26.756,19.151,19.151,0,1,0-32.146-20.045,19.113,19.113,0,0,1,15.491-6.711Z",
    transform: "translate(-529.875 -258.936)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.96,494.778h0a10.411,10.411,0,0,1-10.411-10.244c-.127-7.913-.192-17.667-.192-18.781a28.131,28.131,0,0,1,1.159-8.01h0a28.458,28.458,0,0,1,1.644-3.8,32.933,32.933,0,0,0-4.636,8.589h0a28.127,28.127,0,0,0-1.159,8.01c0,1.115.066,10.869.192,18.786a10.409,10.409,0,0,0,10.411,10.241h0a10.413,10.413,0,0,0,9.994-7.493A10.372,10.372,0,0,1,584.96,494.778Z",
    transform: "translate(-541.59 -384.047)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.733,685.053a13.763,13.763,0,0,1-5.108-21.392,13.764,13.764,0,1,0,18.723,19.889,13.756,13.756,0,0,1-13.615,1.5Z",
    transform: "translate(-535.712 -531.009)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M404.818,445.911s20.476,42.67,6.825,44.378-17.063-38.4-17.063-38.4Z",
    transform: "translate(386.485 302.273)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.649,556.287,618.905,566.7,571.254,510.93l23.234-15.366Z",
    transform: "translate(911.865 482.808)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.932,558.374H470.769l-8.432-52.546h30.6Z",
    transform: "translate(874.7 515.956)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.949,412.556l-66.171-47.268a12.862,12.862,0,1,0-15.451,11.076c8.272,6.944,68.685,67.028,77.335,63.858,8.779-3.216,47.165-9.039,47.165-9.039l1.069-36.446Z",
    transform: "translate(546.974 200.879)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.366,458,705.2,547.223s15.422,132.706,21.109,155.124S745.742,807,745.742,807h42.726l-20.02-120.181,7.305-112.409,42.128,112.656,90.851,97.925,31.407-22.922L858.855,640.179,830.416,528.087s3.541-57.978-28.328-80.305Z",
    transform: "translate(583.372 229.257)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.805,69.417a34.9,34.9,0,1,1,28.776-8.9L66.341,85.2,33.43,89.569Z",
    transform: "translate(1290.454 454.078)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.076,168.225l-1.667-.768c3.479-7.021,10.183-37.774,6.442-44.669-3.59-6.62-10.055-11.324-13.626-17.958a30.1,30.1,0,0,1-2.891-18L0,67.964,45.769,20.879c.649-.669,1.321-1.345,2.015-2.013.15-5.7-2.52-9.967,4.575-13.945,5.9-3.31,32.112-6.254,38.6-4.289,9.6,2.9,11.782,9.711,16.283,18.676a185.374,185.374,0,0,1,15.774,119.613c-1.71,8.289,8.853,11.908,1.929,16.782-4.7,3.317-23.908,9.472-29.6,10.2a376.689,376.689,0,0,1-47.209,2.972Q37.1,168.873,26.076,168.225Z",
    transform: "translate(1268.87 532.55)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.074,431.623c-3.216-8.78-9.04-47.165-9.04-47.165l-36.446-1.068,17.818,43.948-48.623,68.069s.09.15.254.416a12.859,12.859,0,1,0,10.785,13.665.888.888,0,0,0,1.113-.191C754.349,502.507,816.289,440.4,813.074,431.623Z",
    transform: "translate(597.659 214.827)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.179,425.219c-3.346-14.118-6.716-28.315-12.355-41.682s-13.714-26-25.07-35.027a29.316,29.316,0,0,0-12.242-6.334c-4.553-.9-9.68.107-12.876,3.469-5.115,5.379-3.575,14.014-1.7,21.2l16.592,63.529,47.922-5.08Z",
    transform: "translate(606.258 196.989)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.76,6.273s-5.587-4.486-7.821-3.365-20.72,26.38-20.72,26.38S-11.362,48.352,6.516,50.6s67.042-22.43,67.042-28.034S60.435,0,60.435,0,50.7,14.122,41.76,6.273Z",
    transform: "translate(1472.102 1020.254) rotate(-4.012)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.459,21.646s-2.08-6.426-4.576-6.268S20.5,31.565,20.5,31.565s-30.078,7.944-14.5,17,70.477,5.551,72.669.388-2.863-25.76-2.863-25.76-16.192,9.175-21.347-1.544",
    transform: "translate(1291.957 1036.111)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(631.04 440.497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.694,724.945l16.654,31.593-27.742,8.091L174.7,736.057Z",
    transform: "translate(-109.089 -144.167)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.1,792.282l29.325,15s45.9,10.941,16.013,20.033-43.333,2.629-43.333,2.629-39.089,2.032-38.46-8.873,8.149-26.242,8.149-26.242S314.961,801.671,317.1,792.282Z",
    transform: "translate(-219.045 -183.547)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.793,441.963l12.8,154.894s.427,92.595,14.082,110.517,14.078,26.887,14.078,26.887l28.165-14.512s-14.508-24.175-11.521-27.876a20.629,20.629,0,0,0,3.84-7.968l-7.681-95.582,14.508-166.415Z",
    transform: "translate(-226.783 -134.707)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.578,787.911",
    transform: "translate(-225.941 -188.358)",
    fill: "none",
    stroke: "#090814",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.239,724.359l-11.948,31.576-34.136-12.8,21.336-22.189Z",
    transform: "translate(-102.241 -143.581)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.961,445.18,359.786,587.7s-33.282,94.734-62.3,110.089c0,0,0,18.775-6.825,22.189a17.139,17.139,0,0,0-8.534,10.238l-37.55-9.387,17.063-27.309,37.55-91.321s5.973-2.561,7.681-11.1,5.12-8.534-3.413-10.238-8.534-10.238-8.534-10.238L266.763,440.907Z",
    transform: "translate(-222.566 -137.492)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22450.215,7083.071c2.246-2.815,4.131-22.66,5.146-35.884a34.145,34.145,0,1,1,31.127,20.088c-.469,0-.934-.01-1.4-.029.313,9.763.973,19.23.973,19.23s-3.221.069-7.736.069C22467.066,7086.548,22447.779,7086.113,22450.215,7083.071Z",
    transform: "translate(-22386.818 -6983.185)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.018,783.828s11.283-6.992,12.695-4.195,7.052,14.684,7.052,14.684l6.347,17.479s38.786,24.472,5.642,25.87-41.607-17.479-41.607-17.479-37.376-16.082-31.735-25.87,25.39-19.942,25.39-19.942S245.671,791.52,252.018,783.828Z",
    transform: "translate(-209.833 -187.977)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.533,76.782c2.635-1.194,5.617-1.291,8.431-1.963a21.71,21.71,0,0,0,15.87-23.412,12.422,12.422,0,0,1-.276-4.035c.557-2.974,3.736-4.719,6.716-5.22s6.1-.218,8.975-1.151a13.459,13.459,0,0,0,8.5-10.3A22.3,22.3,0,0,0,85.589,17.1l-1.245,2.994a11.33,11.33,0,0,1-3.153-5.4,7.153,7.153,0,0,0-5.71,4.043c-1.765.9-1.761-3.239-3.6-3.963a3.385,3.385,0,0,0-2.385.437c-3.9,1.538-8.215-.243-12.223-1.47a46.275,46.275,0,0,0-21.433-1.328,25.7,25.7,0,0,0-13.063,5.747,30.441,30.441,0,0,0-6.547,9.82c-4.144,8.825-7.106,18.465-6.514,28.2a40.405,40.405,0,0,0,8.2,21.944C20.44,81.413,28.629,92.857,33.6,91.294c6.24-1.966-1.48-11.15,5.935-14.51",
    transform: "translate(42.319 -11.724)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.407,216.454c-.8-.159-3.316-5.341-6.889-13.665l.921,28.17S25,222.424,7.078,230.96c0,0-.853-19.629-2.555-22.188C3.273,206.9,1.122,132.46.046,92.264A88.553,88.553,0,0,1,22.452,30.479c5.175-5.723,10.951-10.523,17.057-12.87,0,.007-1.706-16.2,6.832-17.064,0,0,32.427-3.411,44.374,6.83a88.253,88.253,0,0,0,12.221,8.74A25.079,25.079,0,0,1,113.587,29a25.174,25.174,0,0,1,3.361,9.482l12.171,86.658,17.066,69.122s8.534,7.683,5.115,11.947,4.272,22.2,4.272,22.2l-21.334,6.823S131.671,217.307,127.407,216.454Z",
    transform: "translate(11.517 86.109)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.078,268.411l51.629,139.678S315.784,313.642,314.078,268.411Z",
    transform: "translate(-232.756 -112.205)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M506.18,32.179a12.693,12.693,0,0,0,12.8,16.934l.217-.014h0a21.514,21.514,0,0,1,.411,26.348h0a74.482,74.482,0,0,0,4.657,29.709s3.648,21.778,9.992,26.645,15.382-7.178,15.382-7.178-.03,12.377,8.613,11.409,21.73,4.893,25.96-15.279-10.354-57.337-10.354-57.337l-7.944-31.774A41.758,41.758,0,0,0,514.682,1.41L497.4,6A24.759,24.759,0,0,0,480.15,37.385h0l26.029-5.206",
    transform: "translate(809.576 439.793)",
    fill: "#090814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCustomers);
export default __webpack_public_path__ + "static/media/no-customers.9b25bce63fa627b1188141c511e78f91.svg";
export { ForwardRef as ReactComponent };